import React, { useEffect, useState } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import { compose } from 'redux'
import { getTokenSaga } from './saga'
import injectSaga from '../../utils/injectSaga'
import { getTokenAgency, hideModal, setAgencyTrainings } from '../App/actions'
import '../../fonts/fonts.css'
import SideBar from '../SideBar/index'
import PageHeader from '../../components/PageHeader'
import AddStudent from '../../images/Add.svg'
import ModalConfirm from '../../components/ModalConfirm/index'
import config from '../../config/configurator'
import {
  Bg, MainLayout, Container,
  FormCard, Divider, SectionTitle,
  FieldGroup, FieldLabel, Input, FeedBack,
  EntitySelectorContainer, EntitySelector,
  CreateBtn, SuccessToast,
} from './styledComponents'

const AgencyCreate = () => {
  const defaultAgencyTrainings = ['REMC', 'EVAL']
  const dispatch = useDispatch()
  const agencyToken = useSelector((state) => state.toJS().global.agencytoken)
  const error = useSelector((state) => state.toJS().global.error)
  const successStore = useSelector((state) => state.toJS().global.success)
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [autorisation, setAutorisation] = useState('')
  const [agencyPassword, setAgencyPassword] = useState('')
  const [repeatPassword, setRepeatPassword] = useState('')
  const [wrongRepeat, setWrongRepeat] = useState()
  const [errorCode, setErrorCode] = useState(0)
  const [show, setShow] = useState(false)
  const [modalText, setModalText] = useState(false)
  const [enable, setEnable] = useState(false)
  const [verif, setVerif] = useState(false)
  const [success, setSuccess] = useState(false)
  const [warn, setWarn] = useState({ mail: false, psw: false, fName: false, error: false })
  const [borderColor, setBorderColor] = useState({ mail: '', psw: '' })
  const [color, setColor] = useState()
  const [backgroundColor, setBackgroundColor] = useState()
  const [entity, setEntity] = useState('TGD')
  const [agencyTrainings, setTrainings] = useState(defaultAgencyTrainings) //REMC
  const [agencyTrainingIds, setAgencyTrainingIds] = useState([])

  useEffect(() => {
    displayModal(successStore)
    if (config.title !== 'ML ADMIN') {
      emailCheck()
      verification()
      passwordCheck()
    } else {
      verificationML()
      passwordCheck()
    }
    setErrorCode(0)
    if (!successStore) {
      if (error) {
        if (error !== undefined && error.response !== undefined) {
          switch (error.response.status) {
            case 401:
              setShow(true); setSuccess(false); setWarn({ error: true }); setModalText('Vous n\'êtes pas identifié, veuillez vous déconnecter puis vous reconnecter'); setErrorCode(error)
              break
            default:
              setShow(true); setSuccess(false); setWarn({ fName: true }); setModalText('Erreur système'); setErrorCode(error.response.status)
              break
            case 409:
              setShow(true); setSuccess(false); setWarn({ error: true }); setModalText(`L'agence existe déjà.`); setErrorCode(error.response.status)
              break
            case 500:
              setShow(true); setSuccess(false); setWarn({ error: true }); setModalText(`L'agence existe déjà.`); setErrorCode(error.response.status)
              break
          }
        } else {
          setShow(true); setSuccess(false); setWarn({ error: true }); setModalText('Impossible d\'accéder au serveur'); setErrorCode(error)
        }
      }
    }
    // eslint-disable-next-line
  }, [error, successStore])

  const displayModal = (show) => {
    if (show) {
      setSuccess(true)
      setTimeout(() => {
        dispatch(hideModal())
        setSuccess(false)
      }, 2000)
    }
  }

  const passwordCheck = () => {
    if (repeatPassword && agencyPassword && (agencyPassword !== repeatPassword)) {
      setWrongRepeat(true)
      setBackgroundColor('#EFF0F6')
      setColor('#868383')
      console.log('wrongRepeat', wrongRepeat)
    } else {
      setWrongRepeat(false)
    }
  }

  const onKeyPress = (event) => {
    if (event.key === 'Enter') {
      clickHandlerAccount()
    }
  }

  const clickHandlerAccount = () => {
    if (!verif) {
      return null
    } else {
      const selectedAgencyTrainings = Array.isArray(agencyTrainings) && agencyTrainings.length > 0
        ? agencyTrainings
        : defaultAgencyTrainings
      setWrongRepeat(false)
      setErrorCode(200)
      setName('')
      setEmail('')
      setAgencyPassword('')
      setEntity('TGD')
      setRepeatPassword('')
      setAutorisation('')
      setTrainings(defaultAgencyTrainings)
      setAgencyTrainingIds([])
      dispatch(getTokenAgency(name, agencyPassword, agencyToken, entity, email, autorisation, selectedAgencyTrainings, agencyTrainingIds))
      dispatch(setAgencyTrainings(selectedAgencyTrainings))
      setTimeout(() => {
        setSuccess(false)
      }, 2000)
    }
  }

  const verification = () => {
    if (name && agencyPassword && email && repeatPassword && !wrongRepeat && !warn.mail && !warn.psw) {
      setBackgroundColor('#00C4F3')
      setColor('black')
      setEnable(true)
      setVerif(true)
    } else {
      setBackgroundColor('#EFF0F6')
      setColor('#868383')
      setEnable(false)
      setVerif(false)
    }
  }

  const verificationML = () => {
    if (name && agencyPassword && repeatPassword && !wrongRepeat && !warn.psw) {
      setBackgroundColor('#00C4F3')
      setColor('black')
      setEnable(true)
      setVerif(true)
      setEmail(name + '@b.com')
    } else {
      setBackgroundColor('#EFF0F6')
      setColor('#868383')
      setEnable(false)
      setVerif(false)
    }
  }

  const emailCheck = () => {
    if (!email) {
      setBorderColor({ mail: '#B3ABBC' })
      setWarn({ mail: false })
      return true
    }
    const expReg = /\S+@\S+\.\S+/
    const result = email.match(expReg)
    if (result == null) {
      setBorderColor({ mail: '#FF0000' })
      setWarn({ mail: true })
      return false
    } else {
      setBorderColor({ mail: '#B3ABBC' })
      setWarn({ mail: false })
      return true
    }
  }

  const entities = [
    { value: 'TGD', label: 'TGD' },
    { value: 'IO', label: 'ICI OFFICE' }
  ]

  const DisplayEntitySelector = () => (
    <EntitySelector
      classNamePrefix='react-select'
      multiple={false}
      isSearchable={false}
      value={entities ? entities.value : null}
      placeholder={<p style={{ color: 'black' }}>{entities[0].label}</p>}
      onChange={(e) => { setEntity(e.value) }}
      options={entities}
    />
  )

  return (
    <Bg>
      <SideBar />
      <MainLayout>
        <ModalConfirm
          show={show}
          text={'Attention'.toUpperCase()}
          confirm={() => setShow(false)}
          name={modalText}
          confirmText='OK'
          noCancel
        />
        {success && <SuccessToast>✓ L'agence a bien été créée !</SuccessToast>}

        <PageHeader icon={AddStudent} title='Créer une agence' subtitle='Configurez un nouveau compte auto-école' />

        <Container>
          <FormCard>

            {/* ── Informations ── */}
            <div>
              <SectionTitle>Informations</SectionTitle>
              <FieldGroup>
                <FieldLabel>Nom de l'agence</FieldLabel>
                <Input
                  value={name}
                  style={{ borderColor: errorCode === 409 ? '#EF4444' : '' }}
                  onKeyUp={() => config.title === 'ML ADMIN' ? verificationML() : verification()}
                  onChange={(e) => setName(e.target.value)}
                />
                {warn.fName && <FeedBack>Tous les champs ne sont pas valides</FeedBack>}
                {errorCode === 409 && <FeedBack>L'agence existe déjà</FeedBack>}
              </FieldGroup>

              {config.title !== 'ML ADMIN' && (
                <FieldGroup style={{ marginTop: '1rem' }}>
                  <FieldLabel>Email</FieldLabel>
                  <Input
                    value={email}
                    style={{ borderColor: borderColor.mail }}
                    onKeyUp={() => { verification(); emailCheck() }}
                    onChange={(e) => { setEmail(e.target.value) }}
                  />
                  {warn.mail && <FeedBack>Email non valide</FeedBack>}
                </FieldGroup>
              )}
            </div>

            <Divider />

            {/* ── Accès ── */}
            <div>
              <SectionTitle>Accès</SectionTitle>
              <FieldGroup>
                <FieldLabel>Mot de passe</FieldLabel>
                <Input
                  value={agencyPassword}
                  type='text'
                  style={{ borderColor: wrongRepeat ? '#EF4444' : '' }}
                  onKeyUp={() => config.title === 'ML ADMIN' ? verificationML() : verification()}
                  onChange={(e) => setAgencyPassword(e.target.value)}
                />
              </FieldGroup>
              <FieldGroup style={{ marginTop: '1rem' }}>
                <FieldLabel>Répéter le mot de passe</FieldLabel>
                <Input
                  value={repeatPassword}
                  type='text'
                  style={{ borderColor: wrongRepeat ? '#EF4444' : '' }}
                  onKeyUp={() => config.title === 'ML ADMIN' ? verificationML() : verification()}
                  onKeyPress={onKeyPress}
                  onChange={(e) => { setRepeatPassword(e.target.value) }}
                />
                {wrongRepeat && <FeedBack>Les mots de passe ne correspondent pas</FeedBack>}
              </FieldGroup>
            </div>

            <Divider />

            {/* ── Agrément ── */}
            <div>
              <SectionTitle>Agrément</SectionTitle>
              <FieldGroup>
                <FieldLabel>N° d'autorisation d'enseigner</FieldLabel>
                <Input
                  value={autorisation}
                  onKeyPress={onKeyPress}
                  onKeyUp={() => config.title === 'ML ADMIN' ? verificationML() : verification()}
                  onChange={(e) => setAutorisation(e.target.value)}
                />
              </FieldGroup>
            </div>

            {/* ── Type d'agence (PP ADMIN uniquement) ── */}
            {config.title === 'PP ADMIN' && (
              <>
                <Divider />
                <div>
                  <SectionTitle>Type d'agence</SectionTitle>
                  <EntitySelectorContainer>
                    {DisplayEntitySelector()}
                  </EntitySelectorContainer>
                </div>
              </>
            )}

            <Divider />

            <CreateBtn disabled={!enable} onClick={() => clickHandlerAccount()}>
              Créer l'agence
            </CreateBtn>

          </FormCard>
        </Container>
      </MainLayout>
    </Bg>
  )
}

const withConnect = connect(null, null)
const withSaga = injectSaga({ key: 'AgencyCreate', saga: getTokenSaga })
const arg = compose(withSaga, withConnect)(AgencyCreate)

export default arg
